import { useSelector } from 'react-redux';
import { getFlight } from '../../../../Checkout/store/order/selectors';
import { splitByDirection } from './splitByDirection';
import { groupByProduct } from './groupByProduct';
export const useInsuranceGroups = (items, activeGroupId) => {
    var _a, _b;
    const segmentGroups = ((_b = (_a = useSelector(getFlight)) === null || _a === void 0 ? void 0 : _a.segmentGroups) !== null && _b !== void 0 ? _b : []);
    const filteredSegmentGroups = activeGroupId
        ? segmentGroups.filter(segmentGroup => segmentGroup.groupId === activeGroupId)
        : segmentGroups;
    return groupByProduct(items).map(productItems => ({
        items: productItems,
        directions: splitByDirection(productItems, filteredSegmentGroups)
    }));
};
